import script from "./SummaryReportContributor.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReportContributor.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReportContributor.vue?vue&type=style&index=0&id=66167544&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66167544"]])

export default __exports__